export default "__VITE_ASSET__2jF$mKbT__"